import Link from "next/link";
import { getLandingPageUrl } from "../../core/maintainxUrl";
import ExternalLink from "../ExternalLink/ExternalLink";
import { ArrowIcon2, industryIconMap } from "../Icons/Icons";
import { NavbarSubMenu, NavbarSubMenuItem } from "../Navbar/Navbar";
import styles from "./NavbarSubMenu.module.css";

interface IProps {
  subMenu: NavbarSubMenu;
}
export default function NavBarSubMenu({ subMenu }: IProps) {
  const isResourcesSubMenu = subMenu?.label === "Resources";
  return (
    <div className={styles.subMenuFrame}>
      <div className={styles.subMenu}>
        <h4 className={styles.subMenuTitle}>{subMenu?.label}</h4>
        <div className={styles.subMenuCellFrame}>
          {subMenu?.items?.map((item, i) => (
            <div className={styles.subMenuCell} key={i}>
              {!!item.label && <ItemLink item={item} isResourcesSubMenu={isResourcesSubMenu} />}
              <p className={styles.subMenuCellText}>{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export function ItemLink({
  item,
  isResourcesSubMenu,
}: {
  item: NavbarSubMenuItem;
  isResourcesSubMenu: boolean;
}) {
  const Icon = industryIconMap[item.slug];
  item.icon = Icon ? <Icon width={24} height={24} /> : undefined;

  if (item.externalHref) {
    return (
      <ExternalLink className={styles.subMenuTitleFrame} href={item.externalHref}>
        {!isResourcesSubMenu && item.icon && <div className={styles.subMenuIcon}>{item.icon}</div>}
        <h4 className={styles.subMenuCellTitle}>{item.label}</h4>
        <div className={styles.subMenuArrowIcon}>
          <ArrowIcon2 />
        </div>
      </ExternalLink>
    );
  } else if (item.internalHref) {
    return (
      <a className={styles.subMenuTitleFrame} href={getLandingPageUrl(item.internalHref)}>
        {!isResourcesSubMenu && item.icon && <div className={styles.subMenuIcon}>{item.icon}</div>}
        <h4 className={styles.subMenuCellTitle}>{item.label}</h4>
        <div className={styles.subMenuArrowIcon}>
          <ArrowIcon2 />
        </div>
      </a>
    );
  } else {
    return (
      <Link href={`/${item.slug}`} className={styles.subMenuTitleFrame}>
        {!isResourcesSubMenu && item.icon && <div className={styles.subMenuIcon}>{item.icon}</div>}
        <h4 className={styles.subMenuCellTitle}>{item.label}</h4>
        <div className={styles.subMenuArrowIcon}>
          <ArrowIcon2 />
        </div>
      </Link>
    );
  }
}
